import { render } from "./SafetyVideosUnauth.vue?vue&type=template&id=40126945"
import script from "./SafetyVideosUnauth.vue?vue&type=script&lang=js"
export * from "./SafetyVideosUnauth.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__